import type { JSX } from 'react';
interface TagProps {
  children: React.ReactNode;
  className?: string;
}

export default function Tag({ children, className = '' }: TagProps): JSX.Element {
  return (
    <span className={`tag ${className}`}>{children}</span>
  );
}
